// 微信公众号
export const qrcode = [
  // {
  //   imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/XX.jpg',
  //   name: '新东方小学',
  //   intro: '小学资讯 备考辅导'
  // },
  {
    imgUrl: 'http://file.xdf.cn/uploads/210204/182_210204172937zu3l55sztkO4Vr1E.png',
    name: '新东方网',
    intro: '专注为家长和学生提供优质学习内容和精彩课程'
  },
  // {
  //   imgUrl: 'http://file.xdf.cn/uploads/210126/1115_210126165749Zn6PG52zS0BUcVer.png',
  //   name: '新东方分级阅读',
  //   intro: '为3-12岁儿童提供原版英文分级读物的平台'
  // },
  {
    imgUrl: 'http://file.xdf.cn/uploads/210804/1368_20210804103105.jpg',
    name: '新东方素养课堂',
    intro: '品味国学经典，亲近人文艺术，探秘自然科学'
  },
  // {
  //   imgUrl: 'http://file.xdf.cn/uploads/191127/1368_20191127161951.jpg',
  //   name: 'XDF英语学习',
  //   intro: '每日为您推荐精华英语学习内容'
  // },
  // {
  //   imgUrl: 'http://file.xdf.cn/uploads/180123/182_180123100737ZaTexqk2mOemC6Wv.jpg',
  //   name: '新东方中考',
  //   intro: '中考快讯 专业辅导'
  // },
  // {
  //   imgUrl: 'http://file.xdf.cn/uploads/161020/182_161020174644cpUh6kHZouE4npMf.jpg',
  //   name: '新东方高考',
  //   intro: '新东方高考更快更专业'
  // },
  {
    imgUrl: 'http://file.xdf.cn/uploads/191211/1368_20191211143953.jpg',
    name: '新东方四六级考研',
    intro: '四六级考研干货一网打尽'
  },
  // {
  //   imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/KY.jpg',
  //   name: '新东方考研',
  //   intro: '考研资讯干货提供平台'
  // },
  {
    imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/TF.jpg',
    name: '新东方托福',
    intro: '考前独家预测 一手留学资讯'
  }, {
    imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/YS.jpg',
    name: '新东方雅思',
    intro: '雅思预测解析备考指导'
  }, {
    imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/GRE.jpg',
    name: 'GRE',
    intro: '赴美读研申请备考精品资料'
  },
  // {
  //   imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/GMAT.jpg',
  //   name: '新GMAT满分备考',
  //   intro: '最新资讯 名师辅导'
  // }, {
  //   imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/Elive.png',
  //   name: '新东方e学微服务',
  //   intro: '这一刻，爱上学习！'
  // },
  {
    imgUrl: 'http://images.xdf.cn/cms20150819/zuixinban/img/wx/mg.png',
    name: '蓝思阅读',
    intro: '让你爱上英文阅读'
  }, {
    imgUrl: 'http://file.xdf.cn/uploads/171011/145_171011100630moPopJOBClc94MKk.jpg',
    name: '新东方家庭教育',
    intro: '精品文字 在线互动 专家答疑'
  }, {
    imgUrl: 'http://file.xdf.cn/uploads/200915/1368_20200915103938.png',
    name: '新东方国际服务号',
    intro: '国际教育、留学备考全面指导'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/home/qrcode.js